import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import bgimage from './assets/images/login.jpg';
import './Login.css';

/**
 * Public page reached from the "forgot password" email link:
 *   https://app.cataam.com/#/reset-password?token=...
 * Submits the token + new password to the public /reset-password endpoint.
 */
function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (next.length < 8) { setErr(t('ResetPassword.errPasswordTooShort')); return; }
    if (next !== confirm) { setErr(t('ResetPassword.errPasswordsDoNotMatch')); return; }
    setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/reset-password`,
        { token, newPassword: next }, { headers: { 'Content-Type': 'application/json' } });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (e2) {
      setErr(typeof e2.response?.data?.error === 'string'
        ? e2.response.data.error
        : t('ResetPassword.errLinkInvalid'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page" style={{ backgroundImage: `url(${bgimage})` }}>
      <div className="login-card">
        <form className="login-form" onSubmit={submit}>
          <h2>{t('ResetPassword.heading')}</h2>
          {!token && <p className="error-message">{t('ResetPassword.missingToken')}</p>}
          {err && <p className="error-message">{err}</p>}
          {done ? (
            <p style={{ color: '#15803d', fontSize: '0.9rem' }}>
              {t('ResetPassword.successRedirect')}
            </p>
          ) : (
            <>
              <label>{t('ResetPassword.newPasswordLabel')}</label>
              <input type="password" value={next} onChange={e => setNext(e.target.value)}
                required autoComplete="new-password" placeholder={t('ResetPassword.newPasswordPlaceholder')} />
              <label>{t('ResetPassword.confirmPasswordLabel')}</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                required autoComplete="new-password" placeholder={t('ResetPassword.confirmPasswordPlaceholder')} />
              <button type="submit" disabled={busy || !token}>{busy ? t('ResetPassword.saving') : t('ResetPassword.submit')}</button>
            </>
          )}
          <p style={{ marginTop: '1rem', fontSize: '0.875rem', color: '#555' }}>
            <Link to="/login" style={{ color: '#007BFF', textDecoration: 'none' }}>{t('ResetPassword.backToLogin')}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
